export default {
  api: {
    phoneNumber: {
      exists: "Telefoonnummer bestaat al",

      number: {
        notNull: "Voer een telefoonnummer in"
      },
      type: {
        notNull: "Selecteer een type",
        found: "Dit type telefoonnummer bestaat al",
      },
      idd: {
        notNull: "Kies een internationaal doorkiesnummer "
      }
    },


  },
}
